/**
 * Meta Pixel Blocker for International Domains and India
 * 
 * Blocks Shopify's default Meta Pixel events on:
 * - International domains (UAE, Saudi Arabia, UK, Singapore, Malaysia, USA, Europe, Canada, Australia)
 * - India domain (using n8n webhooks instead)
 */

(function() {
  'use strict';
  
  // Block on all domains (both international and India use n8n webhooks)
  // No need to check market - block everywhere
  
  // No-op function that does nothing
  function noOpFbq() {
    // Do nothing - this blocks Shopify's pixel events
    return noOpFbq;
  }
  
  // Block fbq before Shopify's pixel loads
  Object.defineProperty(window, 'fbq', {
    configurable: true,
    enumerable: true,
    get: function() {
      return noOpFbq;
    },
    set: function(value) {
      // Don't allow Shopify to set fbq - keep it blocked
      if (window.location.search.includes('debug_pixel=true')) {
        console.log('Meta Pixel Block: 🚫 Blocked fbq initialization attempt');
      }
    }
  });
  
  // Also block any attempts to call fbq methods
  noOpFbq.init = noOpFbq;
  noOpFbq.track = noOpFbq;
  noOpFbq.trackCustom = noOpFbq;
  noOpFbq.loaded = false;
  
})();

